import { IAuthAccount } from '@common/models/auth-account';
import { IRootState } from '@src/redux/root.state';

export const getIdentity = (state: IRootState): IAuthAccount => state.auth.identity;
